export type BranchRole = "autofix" | "autotune" | "other";

export function branchRole(branch: {
  id: string;
  workflow?: {
    autofixBranchId: string | null;
    autoImproveBranchId: string | null;
  };
}): BranchRole {
  const workflow = branch.workflow;
  if (!workflow) return "other";
  if (workflow.autofixBranchId === branch.id) return "autofix";
  if (workflow.autoImproveBranchId === branch.id) return "autotune";
  return "other";
}
